import React from 'react';

import { Footer, Header, PageLayout } from '../../components';
import PageContent from '../../features/Sims';

const SimsPage = () => {
  return (
    <>
      <Header />
      <PageLayout>
        <PageContent />
      </PageLayout>
      <Footer />
    </>
  );
};

export default SimsPage;
